import * as firebase from 'firebase/app';
import 'firebase/auth';

const firebaseConfig = require('./keys/tamaishiki-admin-dev.json');
firebase.initializeApp(firebaseConfig);

export const firebaseAuth = firebase.auth();
